export const CONFIG = {
  "PROJECTNAME": "kilic",
  "COMPANYNAME": "KILIC",
  "DFTLNGCODE": "de",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10041001",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": false,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": false,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "#0054A5",
    "primary100": "rgb(17,58,238,0.1)",
    "light": "#0054A5",
    "secondary": "#0054A5",
    "dark": "#0054A5",
    "siteColor3": "#fff",
    "menuSecondary": "#0054A5"
  }
};